import { PageTitle } from '@dec/shared';
import { t } from 'i18next';
import * as Icon from 'react-bootstrap-icons';
import { useSearchParams } from 'react-router-dom';

import { PaymentForm } from './paymentForm';
import { PaymentReference } from './paymentReference';

export const RecordPaymentPage = () => {
  const [searchParams] = useSearchParams();
  const id: string = searchParams.get('taxReturnId')!;

  return (
    <>
      <PageTitle title={t('taxpayer-payments.title.pagePayments')} icon={Icon.CurrencyExchange} />

      {/* layout principal de la pagina */}
      <div className="row">
        <div className="col-12 col-md-5 col-lg-4">
          <PaymentReference id={id!} />
        </div>
        <div className="col-12 col-md-7 col-lg-8">
          <PaymentForm id={id} />
        </div>
      </div>
    </>
  );
};
